import { Select } from "antd";
import React, { useMemo } from 'react';
import { useDispatch } from "react-redux";
import { selectRoute } from "../../../util/store/selectors";
import { useSelector } from "../../../util/store/store";
import { filterOption, renderOpts } from "../../../util/varibles/global";
import { routeActions } from "../reducer";
import styles from "./style.module.scss";

const Locations: React.FC = () => {
    const dispatch = useDispatch();
    const params = useSelector(selectRoute.params);
    const locations = useSelector(selectRoute.locations);
    const loading = useSelector(selectRoute.loadingLocations);
    const { source = { id: null }, destination = { id: null } } = params;
    const { source_id = null, destination_id = null } = params || {};
    const valueA = source_id && source_id === source.id ? source_id : null;
    const valueB = destination_id && destination_id === destination.id ? destination_id : null;
    const options = useMemo(() => renderOpts(locations), [locations]);

    const handleChange = (key: any, value: any) => {
        const data = { ...params || {}, [key]: value };
        const { source_id = null, destination_id = null } = data;
        if (source_id && destination_id) {
            dispatch(routeActions.initialDataRequest({ source_id, destination_id }))
        } else {
            if (key === 'source_id')
                data.source = locations.find(item => item.id === value);
            else
                data.destination = locations.find(item => item.id === value);

            dispatch(routeActions.updateParams(data));
        }
    }

    return <div className={styles.body}>
        <div className={styles.description}>
            Select locations to create route
        </div>
        <div className="flex gap-2 mt-2">
            <Select {...{
                className: styles.select,
                showSearch: true,
                loading,
                value: valueA,
                placeholder: 'Select start location',
                onChange: (value: any) => handleChange('source_id', value),
                filterOption: filterOption,
                options
            }} />

            <Select {...{
                className: styles.select,
                showSearch: true,
                loading,
                value: valueB,
                placeholder: 'Select end location',
                onChange: (value: any) => handleChange('destination_id', value),
                filterOption: filterOption,
                options
            }} />
        </div>
    </div>;
};

export default Locations;
